
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(325|706)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
